import colors from './common';

export default {
  primary: colors.purple1,
  secondary: colors.purple2,
  accent: colors.buttermilk,
};
